export default "__VITE_ASSET__CCb4yO$o__"